// Copyright (c) 2016 Deere & Company

import Column from './column';
import SortOption from './sort-option';
import t from 'tcomb';

const View = t.struct({
    columns: t.list(Column, 'Columns'),
    name: t.String,
    sortBy: t.list(SortOption, 'SortBy')
}, 'View');

export const getDefaultState = () =>
    new View({
        columns: [],
        name: '',
        sortBy: []
    });

export default View;



// WEBPACK FOOTER //
// ./src/reports/basic-warranty-estimator/state/view.js